/* 🎨 STYLES */
import { Container, StyledOption } from "./styles";

const SelectEquipment = ({ options, value, onChange, Color}) => {
    return(
        <Container color={Color} value={value ? value : options[0]} onChange={onChange}>
            {options ? options.map((option, index) => (
                <StyledOption color={Color} key={index} value={option.code_ibge ? option.code_ibge : option.id}>
                    {option.nome ? option.nome : option.name || option.id}
                </StyledOption>
            )) : <></>}
        </Container>
    )
}

export default SelectEquipment;